import React from 'react';

import PropTypes from 'prop-types';

import useI18n from '../../hooks/use-i18n';

import '../../styles/revamp/referral-smile-journey.scss';

const ReferralSmileJourneyCard = (props) => {
  const { content, step } = props;
  const i18n = useI18n();
  const countryLocale = i18n.activeLocale;

  return (
    <div className={`referral-smile-journey-card card${step}`}>
      <div className="card-step" />
      <p className={`card-step-no ${countryLocale === 'th-th' ? 'card-th' : ''}`}>{step}</p>
      <div className="card-image-container">
        <div className="card-image-background" />
        <img src={`/img/referral/referral-smile-journey-step${step}.png`} alt="Step" data-gumlet="false" />
      </div>
      <div className="card-content">
        <p
          className="title"
          data-key={`referral::start_smile_journey_section::steps::step${step}::title`}
          data-lokalise=""
        >
          {content.title}

        </p>
        <div className="content-divider" />
        <p
          className="content"
          data-key={`referral::start_smile_journey_section::steps::step${step}::content`}
          data-lokalise=""
        >
          {content.content}
        </p>
      </div>
    </div>
  );
};

export default ReferralSmileJourneyCard;

ReferralSmileJourneyCard.propTypes = {
  content: PropTypes.shape({ title: PropTypes.string, content: PropTypes.string }).isRequired,
  step: PropTypes.number.isRequired
};
